import fetch from '@/api/fetch'


/** 查询项目列表 */
export const getProjectTreeList = param => fetch.post('/proman/getProTreeList', param);

/** 保存项目信息 */
export const saveProject = param => fetch.post('/proman/save', param);

/** 删除信息 */
export const removeProject = param => fetch.post('/proman/delete', param);


/** 获取项目直属人员 */
export const getProjectDirectUser = params => fetch.get('/proman/user/list', {params});


/** 查询项目人员直属能看的项目的企业 */
export const getNotOrgCanDirectSeeOrgs = _ => fetch.get('/proman/pro/org/list');

